// Batches approved-hello-video lookups for listener cards into one request.
const cache = new Map(); // userId -> Promise<video|null>
let pending = new Map();
let timer = null;

const flush = () => {
  const batch = pending;
  pending = new Map();
  timer = null;
  const ids = [...batch.keys()];
  const url = `/api/hello-video/public-batch?userIds=${ids.map(encodeURIComponent).join(',')}`;
  Promise.resolve()
    .then(() => window.fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }))
    .then(r => (r.ok ? r.json() : { videos: {} }))
    .catch(() => ({ videos: {} }))
    .then(j => batch.forEach((resolve, id) => resolve((j && j.videos && j.videos[id]) || null)));
};

export const loadHelloVideo = userId => {
  if (!userId || typeof window === 'undefined' || !window.fetch) return Promise.resolve(null);
  if (cache.has(userId)) return cache.get(userId);
  const p = new Promise(resolve => pending.set(userId, resolve));
  cache.set(userId, p);
  if (!timer) timer = setTimeout(flush, 40);
  return p;
};
